import { Injectable } from "@angular/core";
import { BaseService } from "./base.service";

@Injectable({
  providedIn: "root",
})
export class ProgramService extends BaseService {
  getProgram(
    search: string,
    onSuccess: (data) => void,
    onError: (data) => void = null
  ): any {
    this.get(
      `program/Step/getJson_List?Search=${search}&offset=0&limit=100`
    ).subscribe(
      (resp) => {
        if (resp.alert.code === 200) {
          onSuccess(resp.data);
        } else {
          onError(resp.alert);
        }
      },
      (err) => {
        if (onError) {
          onError(err);
        }
      }
    );
  }

  getProgramDetail(
    param: any,
    onSuccess: (data) => void,
    onError: (data) => void = null
  ): any {
    this.get(`program/Step/getJson_by/${param}`).subscribe(
      (resp) => {
        if (resp.alert.code === 200) {
          onSuccess(resp.data);
        } else {
          onError(resp.alert);
        }
      },
      (err) => {
        if (onError) {
          onError(err);
        }
      }
    );
  }

  getApplicationOptions(
    onSuccess: (data) => void,
    onError: (data) => void = null
  ): any {
    this.get(`/Application/Step/GetList`).subscribe(
      (resp) => {
        if (resp.alert.code === 200) {
          onSuccess(resp.data);
        } else {
          onError(resp.alert);
        }
      },
      (err) => {
        if (onError) {
          onError(err);
        }
      }
    );
  }

  getSearchProgramDetail(
    param: any,
    search: string,
    onSuccess: (data) => void,
    onError: (data) => void = null
  ): any {
    this.get(`program/Step/get_bySeach/${param}?Search=${search}`).subscribe(
      (resp) => {
        if (resp.alert.code === 200) {
          onSuccess(resp.data);
        } else {
          onError(resp.alert);
        }
      },
      (err) => {
        if (onError) {
          onError(err);
        }
      }
    );
  }
}
